import { Pipe, PipeTransform } from '@angular/core';
import {
    CandidateRequiredLabSelectionUi,
    CandidateRequiredLabUi
} from 'src/app/compliance/models/candidate-required-lab-models';

type SelectionUiData = CandidateRequiredLabSelectionUi & CandidateRequiredLabUi;

@Pipe({
    name: 'selectedCandidateRequiredLabSelection',
    standalone: true
})
export class SelectedCandidateRequiredLabSelectionPipe implements PipeTransform {
    transform(
        items: (CandidateRequiredLabSelectionUi | CandidateRequiredLabUi)[] | null | undefined
    ): SelectionUiData[] {
        if (!items) {
            return [];
        }
        const filtered: SelectionUiData[] = [];
        items.forEach((el) => {
            if (el.isSelected) {
                filtered.push(el as SelectionUiData);
            }
        });
        return filtered;
    }
}
